import { cn } from "../utils";

const Avatar = ({
  size = "normal",
  text,
  className,
}: {
  size?: "normal" | "small";
  text: string;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full bg-linear-to-br from-primary-400 to-secondary-400",
        {
          "min-h-9 min-w-9": size === "normal",
          "min-h-6 min-w-6": size === "small",
        },
        className,
      )}
    >
      <p
        className={cn("font-semibold text-white capitalize", {
          "text-xs": size === "small",
          "text-sm": size === "normal",
        })}
      >
        {text}
      </p>
    </div>
  );
};

export default Avatar;
